import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import smsMessagesService from '../services/smsMessagesService';
import ordersService from '../services/ordersService';
import accountsService from '../services/accountsService';
import senderNamesService from '../services/senderNamesService';

const metaServices = {
	smsMessagesService,
	ordersService,
	accountsService,
	senderNamesService,
};

export function useMeta(serviceName: keyof typeof metaServices) {
	const { i18n } = useTranslation();
	const language = i18n.resolvedLanguage || 'fi';

	const { data: meta, isPending } = useQuery({
		queryKey: ['meta', serviceName, language],
		queryFn: async () => {
			const response =
				await metaServices[serviceName].getMetaData(language);
			return response.data.meta;
		},
		staleTime: Infinity,
		refetchOnMount: false,
	});

	return {
		meta,
		isMetaPending: isPending,
	};
}
